import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API_URL } from '../utils/constants';

const inp = {
  background: '#0f172a', border: '1px solid #334155', borderRadius: 8,
  padding: '10px 14px', color: '#e2e8f0', fontSize: 14,
  width: '100%', boxSizing: 'border-box', marginBottom: 12
};
const btn = (bg = '#6366f1') => ({
  background: bg, color: '#fff', border: 'none', borderRadius: 8,
  padding: '12px 20px', cursor: 'pointer', fontWeight: 600,
  fontSize: 14, width: '100%'
});

export default function ResetPasswordPage() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Extract token from ?token=... in URL
  const token = new URLSearchParams(location.search).get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    if (!token) { setError('Invalid or missing reset token'); return; }

    setLoading(true); setError('');
    try {
      const fd = new FormData();
      fd.append('token', token);
      fd.append('new_password', password);
      const res = await fetch(`${API_URL}/reset-password`, { method: 'POST', body: fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Reset failed');
      setDone(true);
      setMsg('Password updated successfully!');
      setTimeout(() => navigate('/'), 3000);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#050516', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif' }}>
      <div style={{ background: '#0f172a', border: '1px solid #1e293b', borderRadius: 16, padding: 40, width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ color: '#6366f1', fontWeight: 800, fontSize: 24, marginBottom: 8 }}>SPECTRAINE</div>
          <h2 style={{ color: '#e2e8f0', margin: 0, fontSize: 20 }}>Reset Your Password</h2>
          <p style={{ color: '#475569', fontSize: 13, marginTop: 6 }}>Enter your new password below</p>
        </div>

        {done ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <p style={{ color: '#10b981', fontWeight: 600 }}>{msg}</p>
            <p style={{ color: '#475569', fontSize: 13 }}>Redirecting you to login...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && (
              <div style={{ background: '#1e293b', borderLeft: '3px solid #ef4444', padding: '10px 14px', borderRadius: 6, color: '#ef4444', fontSize: 13, marginBottom: 16 }}>
                {error}
              </div>
            )}
            <label style={{ color: '#64748b', fontSize: 12, display: 'block', marginBottom: 4 }}>New Password</label>
            <input
              style={inp} type="password" placeholder="Minimum 8 characters"
              value={password} onChange={e => setPassword(e.target.value)}
              autoComplete="new-password" required
            />
            <label style={{ color: '#64748b', fontSize: 12, display: 'block', marginBottom: 4 }}>Confirm Password</label>
            <input
              style={inp} type="password" placeholder="Repeat your new password"
              value={confirm} onChange={e => setConfirm(e.target.value)}
              autoComplete="new-password" required
            />
            <button type="submit" disabled={loading} style={btn(loading ? '#334155' : '#6366f1')}>
              {loading ? 'Updating...' : 'Set New Password'}
            </button>
            <p style={{ textAlign: 'center', marginTop: 16 }}>
              <span onClick={() => navigate('/')} style={{ color: '#6366f1', cursor: 'pointer', fontSize: 13 }}>
                ← Back to login
              </span>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}